import L from 'leaflet'
import { ZOOM } from '~HIOR/constants/mapBounds'
import { MapLayer, LayerManager } from '~HIOR/classes/map'


class BRTPastelProvider extends MapLayer {
    constructor () {
        super('Kleur')
    }

    render (options = {}) {
        return new L.TileLayer(
            'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/pastel/EPSG:28992/{z}/{x}/{y}.png', {
                WMTS: false,
                minZoom: ZOOM,
                maxZoom: 12,
                attribution: '<a href="http://www.pdok.nl">PDOK</a>',
                continuousWorld: true,
                ...options,
            })
    }
}

LayerManager.setDefault(BRTPastelProvider)
